





























































import {
  createComponent,
  inject,
  onMounted,
  computed,
  ref,
  SetupContext,
  reactive
} from "@vue/composition-api";

import MemberKey from "@/components/member-key";
import SnackBar from "../../../Common/SnackBar.vue";
import LinepayChargeKey from "@/components/linepay-charge-key";
import router from "@/router/index";
import SnackbarKey from "@/components/snackbar-key";

interface SnackBar {
  [prop: string]: any;
}

export default createComponent({
  setup(props: {}, context: SetupContext) {
    const linepayChargeStore = inject(LinepayChargeKey);
    if (!linepayChargeStore) {
      throw new Error(`${LinepayChargeKey} is not provided`);
    }
    const memberStore = inject(MemberKey);
    if (!memberStore) {
      throw new Error(`${MemberKey} is not provided`);
    }

    const globalStore = context.root.$store;
    const loadedFlag = ref<boolean>(false);
    const accessToken = computed(() => globalStore.auth.token);
    const member = computed(() => memberStore.member);

    // 登録ボタン押下後のスナックバー制御
    const snackbar = reactive<SnackBar>({
      display: false,
      error: false,
      message: ""
    });
    // storeを注入
    const snackbarStore = inject(SnackbarKey);
    if (!snackbarStore) {
      throw new Error(`${snackbarStore} is not provided`);
    }
    const linepayNumber = ref<string>("");

    const accountForm = ref<HTMLFormElement>();

    // バリデーションルール
    const requireRule = (value: string) => !!value || "必須入力です。";
    const linepayNumberCountRule = (value: string) =>
      value.length == 11 || "11桁で入力してください。";

    // 2.5秒間のスナックバー表示させる
    const displaySnackbar = (message: string) => {
      snackbar.message = message;
      snackbar.error = true;
      snackbar.display = true;
      // 2.5秒後にスナックバーを初期化する
      setTimeout(() => {
        snackbar.display = false;
        snackbar.error = false;
        snackbar.message = "";
      }, 2500);
    };

    const register = async () => {
      // ここでバリデーションチェック
      if (!accountForm.value) return;
      const validResult = accountForm.value.validate();
      if (validResult) {
        // 更新APIを叩く
        await linepayChargeStore
          .updateLinepayAccount(
            member.value.member_no,
            linepayNumber.value,
            member.value.kana_name_1,
            member.value.kana_name_2,
            member.value.birthday,
          )
          .then((response: any) => {
            if (response.status == 200) {
              context.root.$router.push({name: "LinepayAccountComplete"});
            } else {
              displaySnackbar(linepayChargeStore.errorMessage);
            }
            loadedFlag.value = false;
          });
      } else {
        displaySnackbar("入力項目に誤りがあります。");
      }
    };

    onMounted(async () => {
      loadedFlag.value = true;
      memberStore.setAuthorizationHeader(accessToken.value);
      await memberStore.getMember();
      await linepayChargeStore.getLinepayAccount(member.value.member_no);
      loadedFlag.value = false;
      linepayNumber.value = linepayChargeStore.linepayAccount.linepay_number;
    });

    return {
      member,
      loadedFlag,
      register,
      snackbar,
      requireRule,
      linepayNumber,
      linepayNumberCountRule,
      accountForm
    };
  },
  components: { SnackBar }
});
